<tt-page *ngIf="!!get" [ngClass]="{ 'tt-videotutorials--compact': !!selectedVideo }">
    <tt-page-heading>{{ !!selectedVideo ? selectedVideo.video_title : "Videoveiledninger" }}</tt-page-heading>

    <div class="flex-1 tt-video-tutorials__content" style="display: flex">
        <tt-video-tutorial *ngIf="!!selectedVideo" class="tt-video-tutorials__video" [vtKeyno]="selectedVideo.vt_keyno" [videoId]="selectedVideo.videoId"></tt-video-tutorial>

        <tt-card class="tt-videotutorials__list-card" ttClass="height-full flex-column" [ngClass]="{ 'tt-videotutorials__list-card--selected-video': !!selectedVideo }">
            <div style="display: flex; align-items: flex-start">
                <tt-checkbox ttLabel="show_all" ttLabelView="top" [(ttModel)]="get.show_all" style="width: 9rem" (ttModelChange)="loadVideos()"></tt-checkbox>
                <tt-input ttLabel="searchtext" ttLabelView="top" [(ttModel)]="get.searchtext" style="flex: 1"></tt-input>
            </div>
            <tt-select ttLabel="language_id" ttLabelView="top" [(ttModel)]="get.language_id" [ttData]="languages" (ttModelChange)="loadVideos()"></tt-select>
            <ul class="tt-videotutorials__list flex-1 height-full">
                <cdk-virtual-scroll-viewport [itemSize]="!!selectedVideo ? 87 : 185" style="height: 100%; width: 100%">
                    <ng-container *cdkVirtualFor="let video of videos | listFilter : get.searchtext; trackBy: trackById">
                        <li class="tt-videotutorials__item">
                            <article class="tt-videotutorial__article">
                                <div style="position: relative; height: fit-content">
                                    <span *ngIf="video.has_been_read === '1'" style="position: absolute; background: rgba(0, 0, 0, 0.6); top: 0; left: 0; height: 100%; width: 100%"
                                        ><span class="far fa-check" style="position: absolute; top: 50%; left: 50%; color: white; transform: translate(-50%, -50%); font-size: var(--tt-font-size-xl)">
                                        </span
                                    ></span>
                                    <img [src]="video.thumbnail" (click)="selectedVideo = video" />
                                </div>
                                <div>
                                    <h3 class="tt-videotutorial__heading" [style.fontWeight]="video.has_been_read === '1' ? '300' : '500'">
                                        <button (click)="selectedVideo = video">
                                            {{ video.video_title }}
                                        </button>
                                    </h3>
                                    <p class="tt-videotutorial__description" (click)="selectedVideo = video">{{ video.video_description }}</p>
                                </div>
                            </article>
                        </li>
                    </ng-container>
                </cdk-virtual-scroll-viewport>
            </ul>
        </tt-card>
    </div>
</tt-page>
